export enum DocumentFilterType {
	Name = 0,
	DocumentType = 1,
	EffectiveDate = 2
}
